// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"690":"91739ddf","770":"ed904552","942":"01aae0ef","983":"4053a95e"}[chunkId] + ".chunk.js";
};